module.exports = __webpack_public_path__ + "img/sign_apply_method.ad76aaea.png";